module.exports = __webpack_public_path__ + "img/reminder.56539b8d.svg";